import { SpineLayout } from '@pixijs-userland/spine-layout';

export class MagicLayout extends SpineLayout {
    // TODO: pixiLayout
    // TODO: texts styles
}
